import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useAppSelector } from "../hook";
import moment from "moment";

export type DateState = {
  startDate: string;
  endDate: string;
};

const getCurrentMonthRange = () => {
  const now = moment();
  return {
    startDate: now.clone().startOf("month").format("YYYY-MM-DD"),
    endDate: now.clone().endOf("month").format("YYYY-MM-DD"),
  };
};

const initialState: DateState = getCurrentMonthRange();

export const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    setStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
  },
});

export const { setStartDate, setEndDate } = dateSlice.actions;

export const getStoredStartDate = (state: RootState) => state.date.startDate;
export const getStoredEndDate = (state: RootState) => state.date.endDate;

export const useGetStoredStartDate = () => useAppSelector(getStoredStartDate);
export const useGetStoredEndDate = () => useAppSelector(getStoredEndDate);

export default dateSlice.reducer;
